import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { influenzaRoutes } from './custom-influenza/influenza.routes';

const routes: Routes = [...influenzaRoutes];
@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot([...routes], {
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking',
    }),
  ],
})
export class AppRoutingModule {}
